import { useMapEvent } from 'features/mapping/hooks/useMapEvent';
import { useMapInstance } from 'shared/map-exports';

type ClearTimeoutMapProps = {
  clearMobileTimeout: () => void;
};

export const ClearTimeoutMap = (props: ClearTimeoutMapProps): null => {
  const { clearMobileTimeout } = props;
  const map = useMapInstance();

  useMapEvent(
    ['touchend', 'touchcancel', 'touchmove', 'moveend'],
    clearMobileTimeout,
    map,
    true,
  );

  return null;
};
